import React, {PureComponent} from 'react'
import styles from './styles'
import { FormContext, ReadOnly, FileUploadField } from 'components'
import { TextField, Typography, Button, IconButton } from 'components/OptimisedMui'
import DeleteIcon from '@material-ui/icons/Delete'
import { paramScoped, uuid } from 'utils'

export class Marketing extends PureComponent {
  static defaultProps = {
    name: 'Marketing',
    title: 'Marketing information',
  }

  handleAddPartner = event => {
    const {onChange, context} = this.props
    onChange({...context, partners: [...context.partners, {key: uuid()}]})
  }

  handleDeletePartner = paramScoped(index => event => {
    const {onChange, context} = this.props
    onChange({...context, partners: context.partners.filter((partner, i) => i !== index)})
  })

  handleAddGalleryImage = event => {
    const {onChange, context} = this.props
    onChange({...context, galleryImages: [...context.galleryImages, {key: uuid()}]})
  }

  handleDeleteGalleryImage = paramScoped(index => event => {
    const {onChange, context} = this.props
    onChange({...context, galleryImages: context.galleryImages.filter((galleryImage, i) => i !== index)})
  })

  deleteIcon = <DeleteIcon/>

  render = () => {
    const {onChange, context, errorContext, review} = this.props
    return (
      <ReadOnly on={review}>
        <FormContext
          onChange={onChange}
          context={context}
          errorContext={errorContext}
          metaRef={this.props.metaRef}
        >
          <div className={styles.section}>
            <Typography variant='h6'>Partner Logos</Typography>
            <Typography variant="body1" paragraph>Supported file type: .PNG, .GIF or .JPG</Typography>
            {context.partners.map((partner, i) =>
              <div key={i} className={styles.partnerLogo}>
                <TextField member={`partners[${i}].name`} errorMember={`partners['${partner.key}'].name`}
                           meta={{errorLabel: 'Partner Name'}} fullWidth required />
                <FileUploadField member={`partners[${i}].logo`} errorMember={`partners['${partner.key}'].logo`}
                                 meta={{errorLabel: 'Partner Logo'}} required />
                <IconButton className={styles.itemDelete} onClick={this.handleDeletePartner(i)}>{this.deleteIcon}</IconButton>
              </div>
            )}
            <Button variant="contained" className={styles.addButton} onClick={this.handleAddPartner} fullWidth>Add A Partner</Button>
          </div>

          {context.typeOfIssuance === 'product' && (
            <div className={styles.section}>
              <Typography variant='h6'>Image Gallery</Typography>
              <Typography variant="body1" paragraph>Supported file type: .PNG, .GIF or .JPG</Typography>
              {context.galleryImages.map((galleryImage, i) =>
                <div key={i} className={styles.galleryImage}>
                  <FileUploadField member={`galleryImages[${i}].image`} errorMember={`galleryImages['${galleryImage.key}'].logo`}
                                   meta={{errorLabel: 'Gallery Image'}} required />
                  <TextField member={`galleryImages[${i}].description`} errorMember={`galleryImages['${galleryImage.key}'].name`}
                             meta={{errorLabel: 'Gallery Image Alt'}} label="Alt" required fullWidth />
                  <IconButton className={styles.itemDelete} onClick={this.handleDeleteGalleryImage(i)}>{this.deleteIcon}</IconButton>
                </div>
              )}
              <Button variant="contained" className={styles.addButton} onClick={this.handleAddGalleryImage} fullWidth>Add A Gallery Image</Button>
            </div>
          )}

          <div className={styles.section}>
            <Typography variant='h6'>Account URLs for social media/blogs</Typography>
            {context.socialMediaLinks.map((socialMediaLink, i) =>
              <TextField key={socialMediaLink.socialMediaWebsiteId}
                         member={`socialMediaLinks[${i}].linkUrl`}
                         errorMember={`socialMediaLinks['${socialMediaLink.socialMediaWebsiteId}'].linkUrl`}
                         label={socialMediaLink.name} />
            )}
          </div>

        </FormContext>
      </ReadOnly>
    )
  }
}

export default Marketing